import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../../shared/components/notification/notification.service';

export function errorInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const notificationService = inject(NotificationService); 

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      notificationService.showNotification(error, 'Error request', false); 
      return throwError(() => error);
    })
  );
}
